import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const deel = defineConnector({
  identifier: "deel",
  name: "Deel",
  tagLine: "Global payroll and HR platform",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.letsdeel\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Deel API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Deel account and navigate to **Settings > Integrations > API** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API Token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.letsdeel.com/rest/v2/legal-entities",
  },
});
